import convertFormatDate from '../../../shared/utils/convertFormatDate';

export const getLastDate = (coords, coordsState) => {
  if (!coords || !coords.length) return '';

  const lastIndex = coordsState?.length ? coordsState.length - 1 : coords.length - 1;

  if (lastIndex < 0 || lastIndex >= coords.length) {
    return '';
  }

  return coords[lastIndex]?.date;
};

export const getFormattedLastDate = (coords, coordsState, timeZone) => {
  const lastDate = getLastDate(coords, coordsState);

  return lastDate ? convertFormatDate(lastDate, timeZone).toFormat : '';
};

export default getFormattedLastDate;
